import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MyThreadInput } from '../../../shared/data/inputs/my-thread.input';
import { getMyThreadsQuery } from '../../../shared/data/gql/query/get-my-threads.query';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';
import { MyThreadsResponse } from '../../../shared/data/responses/my-threads.response';
import { SendMessagePayloadInput } from '../../../shared/data/inputs/send-message-payload.input';
import { sendMessageMutation } from '../../../shared/data/gql/mutation/send-message.mutation';
import { SendMessageResponse } from '../../../shared/data/responses/send-message.response';
import { FetchResult } from 'apollo-link';
import { ThreadMessagesInput } from '../../../shared/data/inputs/thread-messages.input';
import { threadMessagesQuery } from '../../../shared/data/gql/query/thread-messages.query';
import { ThreadMessagesResponse } from '../../../shared/data/responses/thread-messages.response';
import { SearchMessageThreadInput } from '../../../shared/data/inputs/search-message-thread.input';
import { searchMyThreadParticipantsQuery } from '../../../shared/data/gql/query/search-my-thread-participants.query';
import { SearchMyThreadParticipantsResponse } from '../../../shared/data/models/search-my-thread-participants.response';
import { UpdateMessageStatusResponse } from '../../../shared/data/responses/update-message-status.response';
import { readMessageMutation } from '../../../shared/data/gql/mutation/read-message.mutation';
import { updateMessageStatusMutation } from '../../../shared/data/gql/mutation/update-message-status.mutation';

@Injectable({
  providedIn: 'root'
})
export class DirectMessageService {
  constructor(private apollo: Apollo) {}

  getMyMessageThreads(
    input: MyThreadInput
  ): Observable<ApolloQueryResult<MyThreadsResponse>> {
    return this.apollo.query<MyThreadsResponse>({
      query: getMyThreadsQuery,
      variables: input
    });
  }

  getThreadMessage(
    input: ThreadMessagesInput
  ): Observable<ApolloQueryResult<ThreadMessagesResponse>> {
    return this.apollo.query<ThreadMessagesResponse>({
      query: threadMessagesQuery,
      variables: input
    });
  }

  sendMessage(
    input: SendMessagePayloadInput
  ): Observable<FetchResult<SendMessageResponse>> {
    return this.apollo.mutate<SendMessageResponse>({
      mutation: sendMessageMutation,
      variables: input
    });
  }

  searchForThreads(
    input: SearchMessageThreadInput
  ): Observable<ApolloQueryResult<SearchMyThreadParticipantsResponse>> {
    return this.apollo.query<SearchMyThreadParticipantsResponse>({
      query: searchMyThreadParticipantsQuery,
      variables: input
    });
  }

  readSingleMessage(
    messageID: string
  ): Observable<FetchResult<UpdateMessageStatusResponse>> {
    return this.apollo.mutate<UpdateMessageStatusResponse>({
      mutation: readMessageMutation,
      variables: { messageID }
    });
  }

  updateMessageStatus(input: {
    messageID: string;
    status: 'UNREAD' | 'DELIVERED' | 'READ';
  }) {
    return this.apollo.mutate<UpdateMessageStatusResponse>({
      mutation: updateMessageStatusMutation,
      variables: input
    });
  }
}
